import axiosInstanceUserManagement from "./axiosInstanceUserMangement";

const axiosBaseQueryUserMangement =
  ({ baseUrl } = { baseUrl:process.env.REACT_APP_USER_MANAGEMENT_BASE_URL }) =>
  async ({ url, method, body, params, headers, responseType } :any) => {
    try {
      const result = await axiosInstanceUserManagement({
        url: baseUrl + url,
        method,
        data: body,
        params,
        headers,
        responseType: responseType == undefined ? 'json' : responseType
      })
      console.log(result ,"result");
      return { data: result}
    } catch (axiosError) {
      const err:any = axiosError
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      }
    }
  }

  export default axiosBaseQueryUserMangement;